import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { DefaultLayout, VerticalLayout, HorizontalLayout, DetachedLayout, FullLayout } from 'layouts';
import PrivateRoute from './PrivateRoute';
import Root from './Root';
import { LayoutTypes } from 'appConstants';
import { useRedux } from 'hooks';

// route
const reactRoute = process.env.REACT_APP_REACT_ROUTE || '';

// lazy load all the views

// auth
const Login = React.lazy(() => import('pages/account/Login'));
const Logout = React.lazy(() => import('pages/account/Logout'));
const Register = React.lazy(() => import('pages/account/Register'));
const Confirm = React.lazy(() => import('pages/account/Confirm'));
const ForgetPassword = React.lazy(() => import('pages/account/ForgetPassword'));
const LockScreen = React.lazy(() => import('pages/account/LockScreen'));

// pages
const ErrorPageNotFound = React.lazy(() => import('pages/error/PageNotFound'));
const ServerError = React.lazy(() => import('pages/error/ServerError'));
const Covenant = React.lazy(() => import('pages/covenant'));
const CovenantDdrReport = React.lazy(() => import('pages/covenant/Components/Ddr/components/CovenantDdrReport'));
const Lancamento = React.lazy(() => import('pages/lancamento'));
const Fornecedor = React.lazy(() => import('pages/fornecedor'));
const ContaBancaria = React.lazy(() => import('pages/contaBancaria'));
const Gestor = React.lazy(() => import('pages/gestor'));
// const Lotes = React.lazy(() => import('pages/lotes'));

const loading = () => <div className=""></div>;

type LoadComponentProps = {
    component: React.LazyExoticComponent<React.FC>;
};

const LoadComponent = ({ component: Component }: LoadComponentProps) => (
    <Suspense fallback={loading()}>
        <Component />
    </Suspense>
);

const AllRoutes = () => {
    const { appSelector } = useRedux();

    const { layout } = appSelector((state) => ({
        layout: state.Layout,
    }));

    const getLayout = () => {
        let layoutCls: React.ComponentType = VerticalLayout;

        switch (layout.layoutType) {
            case LayoutTypes.LAYOUT_HORIZONTAL:
                layoutCls = HorizontalLayout;
                break;
            case LayoutTypes.LAYOUT_DETACHED:
                layoutCls = DetachedLayout;
                break;
            case LayoutTypes.LAYOUT_FULL:
                layoutCls = FullLayout;
                break;
            default:
                layoutCls = VerticalLayout;
                break;
        }
        return layoutCls;
    };
    let Layout = getLayout();

    return useRoutes([
        {
            path: `${reactRoute}/account/login`,
            element: <LoadComponent component={Login} />,
        },
        {
            // auth protected routes
            path: reactRoute + '/',
            element: <PrivateRoute roles={'Admin'} component={Layout} />,
            children: [
                {
                    path: 'convenios',
                    element: <LoadComponent component={Covenant} />,
                },
                {
                    path: 'convenios/ddr',
                    element: <LoadComponent component={CovenantDdrReport} />,
                },
                {
                    path: 'lancamentos',
                    element: <LoadComponent component={Lancamento} />,
                },
                {
                    path: 'fornecedores',
                    element: <LoadComponent component={Fornecedor} />,
                },
                {
                    path: 'contasbancarias',
                    element: <LoadComponent component={ContaBancaria} />,
                },
                {
                    path: 'gestores',
                    element: <LoadComponent component={Gestor} />,
                }
            ],
        },
    ]);
};

export { AllRoutes };
